import React from 'react'
import classNames from 'classnames'
import { useDraggable } from '@dnd-kit/core'
import { CSS } from '@dnd-kit/utilities'

export const DraggableImage = ({image, id, fromDroppableId, isDragging = false, isCorrect, childInCategory}) => {
    const isInCategory = fromDroppableId !== 'image-list'
    const {attributes, listeners, setNodeRef, transform} = useDraggable({
        id: id,
        data: {
            fromDroppableId,
        }
    })

    const style = {
        transform: CSS.Translate.toString(transform),
        touchAction: 'none',
        top: (childInCategory * 32) + 'px',
    }
    const imageClasses = classNames('absolute w-full h-full top-0 border rounded-md object-cover transform transition-all ease-in-out', {
        'border-mediumGrey': typeof isCorrect === 'undefined',
        'scale-75': isDragging && !isInCategory,
        'scale-100': !isDragging,
        // 'shadow-lg': isDragging || isInCategory,
    })
    const classes = classNames('absolute outline-none p-2', isInCategory ? `inset-x-0` : 'inset-0', {
        'z-50': isDragging,
        'transition-transform': !isDragging,
    })

    return (
        <div
            ref={setNodeRef}
            style={style}
            {...listeners}
            {...attributes}
            className={classes}
        >
            <div className={'relative pt-[100%]'}>
                <img
                    src={image.filename ?? image.previewUrl }
                    className={imageClasses}
                    style={{
                        boxShadow: (isDragging || isInCategory) ? '0 0 10px rgba(68, 68, 68, 0.4)' : '',
                    }}
                />
            </div>
        </div>
    )
}
